import { render, staticRenderFns } from "./TermControls.vue?vue&type=template&id=3a2773e5&scoped=true&"
import script from "./TermControls.vue?vue&type=script&lang=js&"
export * from "./TermControls.vue?vue&type=script&lang=js&"
import style0 from "./TermControls.vue?vue&type=style&index=0&id=3a2773e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2773e5",
  null
  
)

export default component.exports